$(function () {
    $('form[data-autosubmit] select, form[data-autosubmit] input, form[data-autosubmit] textarea').each(function () {
        let self = $(this);
        self.on("change", function () {
            self.parents("form").submit();
        });
    });
})
